import { ChakraDrawerBody, ChakraDrawerFooter } from "@airhelp/react-ui-components";
import type { HeaderNavProps } from "./HeaderNav.d";

export const MobileMenuContent = ({
  headerButtons,
  menuItems,
}: Pick<HeaderNavProps, "headerButtons" | "menuItems">) => (
  <>
    <ChakraDrawerBody px={10} mt={20} fontSize={{ base: 18, lg: 16 }}>
      {menuItems}
    </ChakraDrawerBody>
    {headerButtons && (
      <ChakraDrawerFooter flexDirection="column" p={10} boxShadow="0px 8px 32px rgba(45, 60, 77, 0.1)">
        {headerButtons}
      </ChakraDrawerFooter>
    )}
  </>
);
